import React, { useEffect, useState, useRef } from 'react';
import { ClientService } from '../../../../../services/ClientService';
import { EditionService } from '../../../../../services/EditionService';
import { Spinner, Card, Tabs, Tooltip, Row, Col, Accordion, Button, Table, Alert, Form, Dropdown, OverlayTrigger, Badge, InputGroup, FormControl } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../../error-manager/ErrorManager";
import ConfirmDialog from '../../../../confirm-dialog/ConfirmDialog';
import Pagination from '../../../../../components/pagination/Pagination';
import { currencyFormat, getFile, granted } from '../../../../../helper/Helper'
import { GlobalContext } from "../../../../../services/GlobalProvider";
import Split from '../../../../../components/split/Split';
import PeriodeFilter from "../../../../../components/periode-filter/PeriodeFilter";
import { useNavigate } from "react-router";
import './Releve.scss';



const Releve = (props) => {

    const [isReleveClientEditionLoading, setIsReleveClientEditionLoading] = useState(false)
    const { parametres, grants } = React.useContext(GlobalContext);
    const navigate = useNavigate();

    const [getReleveLoading, setGetReleveLoading] = useState(false)
    const [isSaveLoading, setIsSaveLoading] = useState(false)
    const [releveData, setReleveData] = useState()
    const [globalError, setGlobalError] = useState()
    const [currentPagination, setCurrentPagination] = useState(1)
    const [newLot, setNewLot] = useState([])
    const [showDetails, setShowDetails] = useState(false)
    const [operationHover, setOperationHover] = useState()

    let releveParams = useRef({
        'start': 0,
        'limit': 25,
        'family': null,
        'search': null,
        'filters': null,
        'sort': 'date',
        'order': 'desc',
        'include_lettrees': false,
        'fields': "_id,type,code,date,client_nom,client_id,observation,total_remise,total_taxes,statut,total_prix_revient,total_brut_ht,total_net_ht,total_ttc,historiques"
    });

    useEffect(() => {
        getReleve()
    }, []);

    function changePagination(p) {
        setCurrentPagination(p)
        releveParams.current['start'] = (releveParams.current.limit * p) - releveParams.current.limit
    }

    function onChangePagination(p) {
        changePagination(p)
        getReleve()
    }

    let getReleveTimeOut;
    function getReleve() {
        window.clearTimeout(getReleveTimeOut);
        getReleveTimeOut = window.setTimeout(function () {
            setGetReleveLoading(true)
            setGlobalError()
            ClientService.getReleve(props.folderId, props.client._id, releveParams.current).then(res => {
                setGetReleveLoading(false)
                setReleveData(res.data ? res.data.data : null)
            }).catch(error => {
                setGetReleveLoading(false)
                setGlobalError(error)
            });
        }, 600);
    }

    function postReleveLettrageAuto() {
        setIsSaveLoading(true)
        ClientService.postReleveLettrageAuto(props.folderId, props.client._id).then(res => {
            getReleve()
            setIsSaveLoading(false)
        }).catch(error => {
            setIsSaveLoading(false)
            setGlobalError(error)
        });
    }

    function postReleveLettrage() {
        setIsSaveLoading(true)
        let operationIdList = []
        for (let operation of newLot) {
            operationIdList.push(operation._id)
        }
        ClientService.postReleveLettrage(props.folderId, props.client._id, { 'operations': operationIdList }).then(res => {
            getReleve()
            setIsSaveLoading(false)
        }).catch(error => {
            setIsSaveLoading(false)
            setGlobalError(error)
        });
    }

    function setFilterDateDebut(date) {
        let filterDateStart = releveParams.current?.filters?.['filter[date]']?.find((element) => element.operator == '>=')
        if (filterDateStart) {
            filterDateStart.value = date
        } else {
            if (releveParams.current?.filters?.['filter[date]']) {
                releveParams.current?.filters?.['filter[date]'].push({ operator: ">=", value: date })
            } else {
                releveParams.current['filters'] = { 'filter[date]': [{ operator: ">=", value: date }] }
            }
        }
    }

    function setFilterDateFin(date) {
        let filterDateEnd = releveParams.current?.filters?.['filter[date]']?.find((element) => element.operator == '<=')
        if (filterDateEnd) {
            filterDateEnd.value = date
        } else {
            if (releveParams.current?.filters?.['filter[date]']) {
                releveParams.current?.filters?.['filter[date]'].push({ operator: "<=", value: date })
            } else {
                releveParams.current['filters'] = { 'filter[date]': [{ operator: "<=", value: date }] }
            }
        }
    }

    function downloadPDF(releve) {
        EditionService.getReleve(props.folderId, releve._id, "pdf").then(res => {
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                getFile(res)
            }
        }).catch(async (error) => {
            if (
                error.request.responseType === 'blob' &&
                error.response.data instanceof Blob &&
                error.response.data.type &&
                error.response.data.type.toLowerCase().indexOf('json') != -1
            ) {
                setGlobalError({ response: JSON.parse(await error.response.data.text()) })
            } else {
                setGlobalError(error)
            }
        });
    }

    function addInLot(e, operation) {
        e.stopPropagation()
        setShowDetails(false)
        if (!newLot.some(op => op._id == operation._id)) {
            setNewLot([...newLot, operation]);
        }
    }

    function removeFromLot(e, operation) {
        e.stopPropagation()
        if (newLot.some(op => op._id == operation._id)) {
            setNewLot(newLot => newLot.filter(op => op._id !== operation._id));
        }
    }

    function getTotalCredit() {
        let total = 0
        for (let operation of newLot) {
            total = (total + operation?.credit)
        }
        return total
    }

    function getTotalDebit() {
        let total = 0
        for (let operation of newLot) {
            total = (total - operation?.debit)
        }
        return total
    }

    function includeLettres(e) {
        releveParams.current['include_lettrees'] = e.target.checked ? true : false
        getReleve()
    }

    function changeDate(dateObject) {
        delete releveParams.current?.filters?.['filter[date]']
        if (dateObject.dateDebut) {
            setFilterDateDebut(dateObject.dateDebut)
        }
        if (dateObject.dateFin) {
            setFilterDateFin(dateObject.dateFin)
        }
        changePagination(1)
        getReleve()
    }

    function getEdition(format) {
        setIsReleveClientEditionLoading(true)

        let params = {
            'filters': releveParams.current.filters,
            'include_lettrees': releveParams.current.include_lettrees,
            'clients': [props.client._id]
        }

        EditionService.getEditions(props.folderId, params, "analyses/relevesclients", format).then(res => {
            setIsReleveClientEditionLoading(false)
            if (res.status == 204 || !res?.data) {
                setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
            } else {
                setGlobalError()
                getFile(res, format)
            }
        }).catch(error => {
            setIsReleveClientEditionLoading(false)
            setGlobalError(error)
        });
    }

    return (
        <div id="Releve">
            {globalError && <ErrorManager error={globalError} fixed="true" />}
            <Row className="mb-3">
                <Col className="d-flex align-items-center">
                    <Button disabled={newLot?.length > 0} variant="secondary" className="d-flex ms-auto me-2" onClick={() => postReleveLettrageAuto()}><i className="material-icons i-lg me-2">auto_awesome</i>Lettrage automatique</Button>
                    <Button disabled={isReleveClientEditionLoading} onClick={() => getEdition("pdf")}>
                        {isReleveClientEditionLoading &&
                            <Spinner animation="border" size="sm" className="me-2" />
                        }
                        Télécharger le relevé (PDF)
                    </Button>
                </Col>
            </Row>

            <div className='mb-3 bg-gray-100 p-3 rounded'>
                <PeriodeFilter onDateChange={(dateObject) => changeDate(dateObject)} />
                <Form.Check
                    className="mt-3"
                    type="checkbox"
                    id="id-include-lettres"
                    label="Inclure les opérations lettrées"
                    onClick={includeLettres}
                    defaultChecked={releveParams.current['include_lettrees']}
                />
            </div>

            {getReleveLoading && <span className="hloader"></span>}

            {(!getReleveLoading && (releveData?.count == 0 || !releveData?.count) && !globalError) && <em>- Aucun élément trouvé -</em>}

            {(!getReleveLoading && releveData?.operations?.length > 0) &&
                <>
                    <Row className="mb-4" >
                        <Col>
                            <Split title="Solde antérieur" border value={currencyFormat(releveData.solde_anterieur)} />
                            {(releveData?.solde_posterieur > 0) &&
                                <Split title="Solde postérieur" border value={releveData.solde_posterieur} />
                            }
                            <Split title="Total des factures sur la période" border value={releveData.total_factures_periode} />
                            <Split title="Total des règlements sur la période" border value={releveData.total_reglements_periode} />
                            <Split title="Solde final" value={releveData.solde_final} />
                        </Col>
                    </Row>

                    <Table /* bordered */ className="table-operations mt-3 border rounded" /* size="sm" */>
                        <thead>
                            <tr>
                                <th className="border-end text-uppercase text-gray-600 small">Date</th>
                                <th className="border-end text-uppercase text-gray-600 small">Pièce</th>
                                <th className="border-end text-uppercase text-gray-600 small">Débit</th>
                                <th className="border-end text-uppercase text-gray-600 small">Crédit</th>
                                <th className="border-end text-uppercase text-gray-600 small">Solde</th>
                                <th className="text-uppercase text-gray-600 small">Lettrage</th>
                            </tr>
                        </thead>
                        {releveData?.operations.map((operation, i) => (
                            <tbody className={"position-relative hover-bg-gray-100"} key={operation._id} onMouseEnter={() => setOperationHover(operation._id)} onMouseLeave={() => setOperationHover()}>
                                <tr>
                                    <td className="border-top border-gray-500" colSpan="8" >
                                        {operation.type == "facture" &&
                                            <span className="py-1 px-2 bg-primary rounded text-white fw-bold me-2 small">F</span>
                                        }
                                        {operation.type == "avoir" &&
                                            <span className="py-1 px-2 bg-success rounded text-white fw-bold me-2 small">A</span>
                                        }
                                        {operation.type == "reglement" &&
                                            <span className="py-1 px-2 bg-gray-700 rounded text-white fw-bold me-2 small">R</span>
                                        }
                                        <span className="text-gray-700 lh-lg">{operation.libelle}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={"border-top border-end " + (operationHover == operation._id ? "border-gray-400 " : "")}>{new Date(operation.date).toLocaleDateString()}</td>
                                    <td className={"border-top border-end " + (operationHover == operation._id ? "border-gray-400 " : "")}>{operation.piece}</td>
                                    <td className={"border-top border-end text-danger-emphasis text-nowrap fw-bold " + (operationHover == operation._id ? "border-gray-400 " : "") + (operation.debit !== 0 ? "bg-danger-subtle" : "")}>{operation.debit !== 0 && <>{operation.debit}</>}</td>
                                    <td className={"border-top border-end text-success-emphasis text-nowrap fw-bold " + (operationHover == operation._id ? "border-gray-400 " : "") + (operation.credit !== 0 ? "bg-success-subtle" : "")}>{operation.credit !== 0 && <>{operation.credit}</>}</td>
                                    <td className={"border-top border-end bg-gray-300 text-gray-700 text-nowrap fw-bold " + (operationHover == operation._id ? "border-gray-400 " : "")}><>{operation.solde}</></td>
                                    <td className={"border-top " + (operationHover == operation._id ? "border-gray-400 " : "")}>{operation?.numlet}</td>

                                    <td className={"border-top " + (operationHover == operation._id ? "border-gray-400 " : "")}>
                                        <span className={"table-actions position-absolute w-auto d-flex align-items-center bg-transparent "}>
                                            {(newLot?.length == 0 && (operationHover == operation._id)) &&
                                                <Button className="shadow" variant="gray-800" onClick={e => addInLot(e, operation)}>Ajouter (nouveau lot)</Button>
                                            }
                                            {newLot?.length > 0 &&
                                                <>
                                                    {!newLot.some(op => op._id == operation._id) &&
                                                        <Button className="shadow" variant="gray-800" onClick={e => addInLot(e, operation)}>Ajouter</Button>
                                                    }
                                                    {newLot.some(op => op._id == operation._id) &&
                                                        <Button className="shadow" variant="gray-600" onClick={e => removeFromLot(e, operation)}>Retirer</Button>
                                                    }
                                                </>
                                            }
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        ))}

                    </Table>
                    <Pagination className="mt-2" itemsLength={releveData?.total} elementsPerPage={releveParams.current.limit} currentPagination={currentPagination} changePagination={p => onChangePagination(p)} />
                </>
            }

            {newLot?.length > 0 &&
                <div className={"new-lot-container d-flex flex-column position-absolute zindex-6000 p-4 bg-primary-700 rounded shadow-lg text-white " + ((showDetails && newLot?.length > 0) ? "new-lot-container-full" : "")}>
                    <div className="d-flex align-items-center">
                        <div>
                            <h6>Nouveau lot :</h6>
                            <div className="d-flex">
                                <div className="d-flex flex-column me-3">
                                    <div className="text-primary-100 small fw-bold">Total crédit</div>
                                    <div className="bg-success px-2 py-1 rounded">+{getTotalCredit()}</div>
                                </div>
                                <div className="d-flex flex-column me-3">
                                    <div className="text-primary-100 small fw-bold">Total débit</div>
                                    <div className="bg-danger px-2 py-1 rounded">{getTotalDebit()}</div>
                                </div>
                                <div className="d-flex flex-column">
                                    <div className="text-primary-100 small fw-bold">Différence</div>
                                    <div className="bg-gray-600 px-2 py-1 rounded">{getTotalCredit() + getTotalDebit()}</div>
                                </div>
                            </div>
                        </div>
                        <span className="ms-auto d-flex align-items-center">
                            <Button variant="outline-light" className="me-2" onClick={() => setNewLot([])}>Annuler</Button>
                            <Button disabled={(getTotalCredit() + getTotalDebit()) !== 0} variant="light" className="me-3" onClick={() => postReleveLettrage()}>Enregistrer</Button>
                            <span className="px-3 py-2 d-inline-flex bg-primary-600 hover-bg-primary-500 rounded cursor-pointer" onClick={() => setShowDetails(!showDetails)}>
                                {showDetails ?
                                    <i className="material-icons icon-open">keyboard_arrow_down</i>
                                    :
                                    <i className="material-icons icon-open">keyboard_arrow_up</i>
                                }
                            </span>
                        </span>
                    </div>
                    {showDetails &&
                        <div className="mt-4 light-v-scroll">
                            {newLot.map(operation => (
                                <span className="ps-3 pe-2 py-2 rounded d-flex align-items-center mb-2 bg-gray-200 text-dark">
                                    {operation.libelle}
                                    <Button variant="gray-600" className="ms-auto" onClick={e => removeFromLot(e, operation)}>Retirer</Button>
                                </span>
                            ))}
                        </div>
                    }



                    {/* {newLot?.map(operation =>(
                        <span>{operation?.libelle}</span>
                    ))} */}

                </div>
            }
        </div>
    );
}
export default Releve;